import AssignByMacros from './AssignByMacros';

export default AssignByMacros;
